import React, { useEffect, useState } from 'react'
import ReactModal from 'react-modal'
import '../../styles/modals/ConfirmationUnlinkAccountModal.css'
import { useTranslation } from 'react-i18next'
import UnlinkAccountImage from '../../svg/normalSvgs/UnlinkAccountImage.png'
import { ReactComponent as TrashIcon } from '../../svg/normalSvgs/TrashIcon.svg'
import { ReactComponent as CloseModalIcon } from '../../svg/normalSvgs/CloseModalIcon.svg'

function ConfirmationUnlinkAccountModal({ modalIsOpen, afterOpenModal, closeModal, currentClass, confirmation, message, subMessage = '' }) {
    const { t, locale } = useTranslation()

    useEffect(() => {
        if (modalIsOpen) {
            ReactModal.setAppElement('#root')
            document.getElementById('feedid').style.filter = 'blur(5px)'
        } else {
            document.getElementById('feedid').style.filter = 'unset'
        }
    }, [modalIsOpen])

    return (
        <ReactModal
            transparent
            closeTimeoutMS={600}
            isOpen={modalIsOpen}
            onAfterOpen={() => {}}
            onAfterClose={() => {}}
            onRequestClose={closeModal}
            className="unlink-account-no-scroll"
            style={{
                overlay: {
                    zIndex: 4,
                },
                content: {
                    padding: 0,
                    opacity: 1,
                    width: 650,
                    margin: 'auto',
                    backgroundColor: 'transparent',
                    height: '100%',
                    maxHeight: '100%',
                    border: 'none',
                    boxShadow: 'none',
                    overflow: 'scroll',
                    paddingTop: 35,
                    paddingBottom: 35,
                },
            }}
        >
            <div className="unlink-account-container">
                <div className="unlink-account-close-button" onClick={() => closeModal()}>
                    <CloseModalIcon />
                </div>

                <div className="unlink-account-body">
                    <p className="unlink-account-title">{message}</p>
                    <p className="unlink-account-subtitle">{subMessage}</p>
                    <div style={{ marginTop: -30, backgroundImage: `url(${UnlinkAccountImage})`, width: 611, height: 242 }}></div>
                    <div className="unlink-account-username">
                        <div className="unlink-account-username-label ">Dummo app user name:</div>
                        <div className="unlink-account-username-text  ">Dummo user</div>
                    </div>

                    <div className="unlink-account-buttons-container">
                        <button className="unlink-account-cancel-button" onClick={() => closeModal()}>
                            <TrashIcon fill="white" />
                            {t('Yes, unlink')}
                        </button>
                        <button className="unlink-account-button" onClick={() => closeModal()}>
                            {t('No, cancel')}
                        </button>
                    </div>
                </div>
            </div>
        </ReactModal>
    )
}

export default ConfirmationUnlinkAccountModal
